import { useCallback, useRef, useState } from 'react';

interface UseTableColumnsConfigResult {
    isOpen: boolean;
    triggerRef: React.RefObject<HTMLDivElement>;
    onOpen: () => void;
    onClose: () => void;
    toggle: () => void;
}

export const useTableColumnsConfig = (): UseTableColumnsConfigResult => {
    const [isOpen, setIsOpen] = useState(false);
    const triggerRef = useRef<HTMLDivElement>(null);

    const onOpen = useCallback(() => {
        setIsOpen(true);
    }, []);

    const onClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    const toggle = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);

    return {
        isOpen,
        triggerRef,
        onOpen,
        onClose,
        toggle,
    };
};
